import React from "react";
import "./Hero.css";

const Hero = () => {
  return (
    <div className="hero">
      <div className="content">
        <h1>What does Bonobo Hope Initiative represent?</h1>
        <p>
          BHI represents a new, fresh perspective on great apes, acknowledging
          their complex personalities and life experiences. Our approach
          includes a revolutionary understanding of two-way linguistic
          communication, with the goal of facilitating a working interspecies
          dialogue. Further, we support enabling the return of all bonobos to
          their natural habitat.
        </p>
      </div>
      <div className="image">
        <img
          src="so-that-together-button.png"
          alt="A button that says So That Together We May Learn of Language"
        />
      </div>
    </div>
  );
};

export default Hero;
